import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField, } from '../../../../../components';
import { Button, Container, Dialog, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box, Radio } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN } from '../../../../../constants/dropdown';


const initialPatientDataObj = {
    data: [],
    loading: false
};
const initialPosDataObj = {
    data: [],
    loading: false
};


export const RadioServiceAcknowledgement = () => {
    const doctorIDRef = useRef();
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
    const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [opdData, setOpdData] = useState([])
    const [selectedRadio, setSelectedRadio] = useState('ipd_service');
    const [opdFilterData, setOpdFilterData] = useState({ data: [] });
    const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
    const productRef = useRef()
    const [productStock, setProductStock] = useState([])
    const [doctorDropdown, setDoctorDropdown] = useState([])
    const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
    const [patientService, setPatientService] = useState(null)
    const [serviceDropdown, setServiceDropdown] = useState([])
    const [radiologyRoomMasterDropdown, setRadiologyRoomMasterDropdown] = useState([])
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const pathParts = pathname.split('/');
    const organisation = pathParts[1];
    const user = JSON.parse(localStorage.getItem('user'));




    const { getValues } = useForm()
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({

            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const IPD_TABLE_HEADER = [
        { header: 'Patient Name', accessor: (row) => row?.patient?.name },
        { header: 'Bill No.', accessor: (row) => row?.bill_no },
        { header: 'Ipd No.', accessor: 'ipd_no' },
        { header: 'Uhid', accessor: (row) => row?.patient?.uhid },
    ];

    const OPD_TABLE_HEADER = [
        { header: 'Patient Name', accessor: (row) => `${row?.patient?.name}` },
        { header: 'Bill No', accessor: (row) => row?.bill_no },
        {
            header: 'Uhid', accessor: "uhid"
        },

    ];


    const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        if (!selectedRecord && !getValues('consultant')) {
            const [defaultState] = data.filter(({ status }) => status === 'default');
            setValue('consultant', defaultState?._id);
            if (defaultState) {
                setValue('department', defaultState.qualification_details.department);
            }
        }
        setDoctorDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getServiceDropdown = useCallback(async () => {
        const data = await dropdownFetch('service');
        setServiceDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getRoomMasterDropdown = useCallback(async () => {
        const data = await dropdownFetch('radiology-room-master');
        setRoomMasterDropdown(data);
    }, [selectedRecord, getValues, setValue]);


    useEffect(() => {
        getDoctorDropdown()
        getServiceDropdown()
        getRoomMasterDropdown()
    }, [getDoctorDropdown, getServiceDropdown, getRoomMasterDropdown])


    const handleRadioChange = (event) => {
        const { name } = event.target;
        setSelectedRadio(name);

    };


    const formSubmit = async (formValues) => {
        setLoading(true);
        const services = patientService
        const serviceBilling = selectedRadio
        const payload = {
            ...formValues,
            services,
            serviceBilling
        };
        try {
            const response = await request('/service-acknowledgement-create', {
                method: 'POST',
                body: {
                    ...payload,
                    createdBy: user.name,
                    organisation
                },
            });

            if (response?.success && response.data) {
                toast(`Successfully ${'created'} Radiology Acknowledgement`, { variant: 'success' });
                setSelectedRecord(response.data);
                fetchIpdPatient()
                fetchOpdPatients()
                setPatientService([])
                reset()
            } else {
                toast(`Failed to ${'create'} Radiology Acknowledgement`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (productStock && productStock.length > 0) {
            setOriginalData(productStock);
            setIsFiltered(false);
        }
    }, [productStock]);

    const handleProductSearch = (searchValue) => {
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = productStock.filter((item) =>
            item.productDetails[0].product?.toString().toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleProductSearch(newInput);
    };


    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleRowClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', row?.patient?.name)
        setValue('uhid', row?.patient?.uhid)
        setValue('ipd_no', row?.ipd_no)
        setValue('consultant', row?.
            indoorRegisteration?.consultant_detail?.
            doctor)
        setValue('gender', row?.patient?.gender)
        setValue('age', calculateAge(row?.patient?.dob))
        setValue('bill_no', row?.bill_no)
        setValue('mobile_no', row?.patient?.
            mobile_no)
    };
    const handleRowOpdClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', `${row?.patient?.name}`)
        setValue('gender', `${row?.patient?.gender}`)
        setValue('age', calculateAge(row?.patient.dob))
        setValue('uhid', row?.uhid)
        setValue('consultant', row?.patient?.consultant)
        doctorIDRef.current = row?.consultant?._id;
        setValue('sponsor', row?.sponsor?._id)
        setValue('bill_no', row?.bill_no)
    };

    const fetchOpdPatients = async () => {
        setPatientDataObj({ loading: true });
        try {
            const acknowledgedResponse = await request('/service-acknowledgement-list', { method: 'GET' });
            const acknowledgedRecords = acknowledgedResponse.success
                ? new Set(acknowledgedResponse.data.map(item => `${item.bill_no}_${item.uhid}`))
                : new Set();
            const response = await request('/opd-billing-list', { method: 'GET' });
            if (response.success) {
                const filteredData = response.data
                    .map(patient => {
                        const filteredServiceItems = patient.service_items.filter(item => item.type === "R");
                        return {
                            ...patient,
                            service_items: filteredServiceItems,
                        };
                    })
                    .filter(patient =>
                        patient.service_items.length > 0 &&
                        !acknowledgedRecords.has(`${patient.bill_no}_${patient.uhid}`)
                    );

                setPatientDataObj({ loading: false, data: filteredData });
            } else {
                toast('Error in fetching data', { variant: 'error' });
                setPatientDataObj({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching patient data:', error);
            toast('Error in fetching data', { variant: 'error' });
            setPatientDataObj({ loading: false });
        }
    };

    const fetchIpdPatient = async () => {
        setIndoorRegisterationDataObj({ loading: true });
        try {
            const acknowledgedResponse = await request('/service-acknowledgement-list', { method: 'GET' });
            const acknowledgedRecords = acknowledgedResponse.success
                ? new Set(acknowledgedResponse.data.map(item => `${item.bill_no}_${item.ipd_no}`))
                : new Set();
            const response = await request('/ipd-billing-list', { method: 'GET' });
            if (response.success) {
                const filteredData = response.data
                    .map(patient => {
                        const filteredServiceItems = patient.service_items.filter(item => item.type === "R");
                        return {
                            ...patient,
                            service_items: filteredServiceItems,
                        };
                    })
                    .filter(patient =>
                        patient.service_items.length > 0 &&
                        !acknowledgedRecords.has(`${patient.bill_no}_${patient.ipd_no}`)
                    );
                setIndoorRegisterationDataObj({ loading: false, data: filteredData });
            } else {
                toast('Error in fetching data', { variant: 'error' });
                setIndoorRegisterationDataObj({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching IPD patient data:', error);
            toast('Error in fetching data', { variant: 'error' });
            setIndoorRegisterationDataObj({ loading: false });
        }
    };


    useEffect(() => {
        fetchIpdPatient()
        fetchOpdPatients()
    }, [])


    const PATIENT_STATUS_HEADER = [
        { header: 'Service Name', accessor: (row) => row?.service_name },
        { header: 'Qty', accessor: (row) => row?.quantity },
        { header: 'Rate', accessor: (row) => row?.rate },
        { header: 'Amount', accessor: (row) => row?.amount },
        { header: 'Discount', accessor: (row) => row?.disc_amt },
        { header: 'Room No.', accessor: (row) => row?.room || 'N/A' },
    ];

    useEffect(() => {
        if (opdData && opdData.length > 0) {
            setOpdFilterData({ data: opdData });
            setIsFiltered(false);
        }
    }, [opdData]);

    const handleOpdDataFilter = (searchValue) => {
        const opdDataArray = opdFilterData.data || [];
        const lowercasedInput = searchValue.toLowerCase();

        const filtered = opdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput)
        );
        setOpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };



    useEffect(() => {
        if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data)) {
            setIpdFilterData({ data: indoorRegisterationDataObj.data });
            setIsFiltered(false);
        }
    }, [indoorRegisterationDataObj]);

    const handleIpdDataFilter = (searchValue) => {
        const ipdDataArray = ipdFilterData?.data || [];
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = ipdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput) ||
            item.ipd_no.toString().includes(lowercasedInput)
        );
        setIpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };

    const handlePatientRowClick = (row) => {
        setPatientService(row.service_items)
        console.log("HELLLO SERVICE ROW", patientService)
    }

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Radiology Service Acknowledge
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                >
                                    Acknowledgement
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Stack spacing={0.2} direction="row" alignItems="center">
                                        <Radio
                                            name="ipd_service"
                                            checked={selectedRadio === 'ipd_service'}
                                            onChange={handleRadioChange}
                                        />
                                        <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Ipd Service Billing</Typography>

                                        <Radio
                                            name="opd_service"
                                            checked={selectedRadio === 'opd_service'}
                                            onChange={handleRadioChange}
                                        />
                                        <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Opd Service Billing</Typography>
                                    </Stack>
                                    <Grid item sx={{ display: 'flex', flexDirection: 'column', marginTop: "1%" }}>
                                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                                            <MuiTextField
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        padding: '0',
                                                        border: '1px solid #66ccff', // Set the border color and width
                                                        borderRadius: '8px', // Set the border radius (optional)
                                                        '&:hover': {
                                                            borderColor: '#66ccff', // Set border color on hover (optional)
                                                        },
                                                        '&.Mui-focused': {
                                                            borderColor: '#66ccff', // Set border color when focused (optional)
                                                        },
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '8px 14px',
                                                        fontSize: '14px', // Font size
                                                    },
                                                }}
                                                label="Search Admitted Patient"
                                                variant="outlined"
                                                value={input}
                                                onChange={handleChange}
                                                inputRef={productRef}
                                            />
                                        </Stack>


                                        {
                                            selectedRadio === 'ipd_service' ? (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', marginTop: '1%' }}
                                                    data={indoorRegisterationDataObj.data || []}
                                                    columns={IPD_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowClick(row);
                                                        handlePatientRowClick(row)
                                                    }}
                                                />
                                            ) : (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', marginTop: '1%' }}
                                                    data={patientDataObj.data || []}
                                                    columns={OPD_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowOpdClick(row);
                                                        handlePatientRowClick(row)
                                                    }}
                                                />
                                            )
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item xs={7} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Stack sx={{ border: "0px solid grey", padding: "5px", borderRadius: "5px", boxShadow: '0px 2px 2px #0099ff' }} spacing={0.5} direction="row">
                                        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Doc No.</Typography>

                                                <TextField
                                                    disabled
                                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                                    name="doc_no"
                                                    placeholder="Doc No."
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Uhid/Ipd No.</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="uhid"
                                                    placeholder="Enter Uhid"
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="ipd_no"
                                                    placeholder="Enter Ipd No."
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Gender/Age</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.4 }}
                                                    name="gender"
                                                    placeholder="Select Gender"
                                                    menus={GENDER_DROPDOWN}
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="age"
                                                    placeholder="Age"
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Mobile No.</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8 }}
                                                    name="mobile_no"
                                                    placeholder="Mobile No."
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Doc Date</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                                    name="date"
                                                    type="date"
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Patient Name</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8 }}
                                                    name="patient_name"
                                                    placeholder="Patient Name"
                                                />

                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Consultant</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.8 }}
                                                    name="consultant"
                                                    placeholder="Select Consultant"
                                                    menus={doctorDropdown}
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Bill No</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8 }}
                                                    name="bill_no"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Stack>
                                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, marginTop: '1%' }}>
                                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3 }}>
                                            <Table
                                                containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                data={patientService || []}
                                                columns={PATIENT_STATUS_HEADER}
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container >
            </Paper >

        </>
    );
};
